export const FETCH_SHOWCASE = 'showcase/FETCH'
export const FETCH_SHOWCASE_SUCCESS = `${FETCH_SHOWCASE}_SUCCESS`
export const FETCH_SHOWCASE_FAIL = `${FETCH_SHOWCASE}_FAIL`

const SHOWCASE_DEFAULTS = {
  5: {
    home: {
      title: process.env.REACT_APP_PRODUCTS_SHOWCASE_TITLE || process.env.REACT_APP_TITLE_SHOWCASE_DEFAULTS || 'Troque seus pontos por produtos dos principais e-commerces.',
      titleOnlyCash: 'Uma seleção de ofertas especiais para você.',
      mobileTitle: 'Produtos'
    },
    'home-shopping': {
      title: process.env.REACT_APP_TITLE_SHOWCASE_DEFAULTS || 'Troque seus pontos por produtos dos principais e-commerces.',
      titleOnlyCash: 'Uma seleção de ofertas especiais para você.',
      mobileTitle: 'Produtos'
    }
  },
  7: {
    home: {
      title: 'Vale-compras para você presentear.',
      mobileTitle: 'Produtos'
    }
  }
}

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_SHOWCASE:
      return {
        ...state,
        [action.showcaseType]: {
          ...state[action.showcaseType],
          [action.identifier]: {
            ...(SHOWCASE_DEFAULTS[action.showcaseType] ? SHOWCASE_DEFAULTS[action.showcaseType][action.identifier] : {}),
            ...(state[action.showcaseType] ? state[action.showcaseType][action.identifier] : {}),
            isLoading: true
          }
        }
      }
    case FETCH_SHOWCASE_SUCCESS:
      return {
        ...state,
        [action.meta.previousAction.showcaseType]: {
          ...state[action.meta.previousAction.showcaseType],
          [action.meta.previousAction.identifier]: {
            ...state[action.meta.previousAction.showcaseType][action.meta.previousAction.identifier],
            isLoading: false,
            ...action.payload.data.showcase,
            products: action.payload.data.products.map(({ sku }) => sku),
            vendors: action.payload.data.vendors
          }
        }
      }
    case FETCH_SHOWCASE_FAIL:
      return {
        ...state,
        [action.meta.previousAction.showcaseType]: {
          ...state[action.meta.previousAction.showcaseType],
          [action.meta.previousAction.identifier]: {
            ...state[action.meta.previousAction.showcaseType][action.meta.previousAction.identifier],
            isLoading: false
          }
        }
      }
    default:
      return { ...state }
  }
}

export const fetchShowcase = (showcaseType, identifier) => ({
  type: FETCH_SHOWCASE,
  showcaseType,
  identifier,
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v2/showcases/${showcaseType}?identifier=${identifier}&cachedPrice=true`
    }
  }
})



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/ducks.js